import { PostHogProvider } from 'posthog-js/react';
import { CaptureResult } from 'posthog-js';

const posthog = {
    api_host: 'https://eu.i.posthog.com',
    api_key: 'phc_iAfomuFV6k0Xea6iIRxtqNolzVl0T0DYffKYSI2z4PC'
};

// Ignore exceptions that are not relevant
const ExceptionBlacklist: string[] = [
    // CanceledError: happens when the user navigates and ongoing requests are canceled
    'CanceledError',

    // AxiosError: happens when the request fails with status code other than 200
    // This is common for unauthorized requests
    'AxiosError'
];

const PostHogWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    return (
        <PostHogProvider
            apiKey={posthog.api_key}
            options={{
                api_host: posthog.api_host,
                before_send: (cr: CaptureResult | null) => {
                    if (cr?.event === '$exception') {
                        const exceptionList = cr?.properties.$exception_list || [];
                        const exception = exceptionList.length > 0 ? exceptionList[0] : null;

                        if (exception && ExceptionBlacklist.includes(exception?.$exception_type)) {
                            return null;
                        }
                    }
                    return cr;
                }
            }}
        >
            {children}
        </PostHogProvider>
    );
};

export default PostHogWrapper;
